"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var GamepadContext_1 = require("../GamepadContext");
var Fullscreen_1 = __importDefault(require("stremio/common/Fullscreen"));
var useHorizontalNavGamepadNavigation = function (gamepadHandlerId, enableGoBack) {
    var gamepad = (0, GamepadContext_1.useGamepad)();
    var _a = (0, Fullscreen_1.default)(), fullscreen = _a[0], toggleFullscreen = _a[3];
    (0, react_1.useEffect)(function () {
        var goBack = function () { return enableGoBack && window.history.back(); };
        gamepad === null || gamepad === void 0 ? void 0 : gamepad.on('buttonY', gamepadHandlerId, toggleFullscreen);
        gamepad === null || gamepad === void 0 ? void 0 : gamepad.on('buttonB', gamepadHandlerId, goBack);
        return function () {
            gamepad === null || gamepad === void 0 ? void 0 : gamepad.off('buttonY', gamepadHandlerId);
            gamepad === null || gamepad === void 0 ? void 0 : gamepad.off('buttonB', gamepadHandlerId);
        };
    }, [gamepad, gamepadHandlerId, enableGoBack, fullscreen]);
};
exports.default = useHorizontalNavGamepadNavigation;
